import { PostData } from "../../common/components/Input/File/File";

export const defaultPostData: PostData = {
  fields: {
    bucket: "test-bucket",
    key: "test-bucket/hello.csv",
    Policy: "abc",
    "X-Amz-Algorithm": "def",
    "X-Amz-Credential": "ghi",
    "X-Amz-Date": "jkl",
    "X-Amz-Signature": "",
  },
  url: "https://uploadurl.com/",
};
